import { TemplateData, TemplateParams } from '.';

const calendarEventFeedbackRequest = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'calendar-events',
  email: {
    buttonEnabled: true,
    buttonLink: '{{feedbackUrl}}',
    buttonText: messages.eventCalendarFeedbackSubmit,
    content: `
      <p>
        ${messages.calendarEventFeedbackRequestContent1}
        ${messages.calendarEventFeedbackRequestContent2}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    heading: messages.emailGreeting,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    subject: `{{siteName}}: ${messages.calendarEventFeedbackRequestSubject}`
  },
  placeholders: {
    eventTitle: {
      label: messages.calendarEventTitle,
      example: 'Test event'
    },
    eventUrl: {
      label: messages.calendarEventLink,
      example: `${serverConfig.adminUrl}/calendar/1`
    },
    feedbackUrl: {
      label: messages.calendarEventFeedbackLink,
      example: `${serverConfig.adminUrl}/calendar/1/feedback`
    },
    eventTime: {
      label: messages.calendarEventDateAndTime,
      example: '27.3.2024 08:00 - 10:00'
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeCalendarEventFeedbackRequest
});

export default calendarEventFeedbackRequest;
